import { Edit2, Link, Share2, Tag, Trash2 } from "react-feather";
import { Href } from "../../../../../../constants";
import { DescriptionProps } from "../../../../../../types/Applications";

// This component handles the description and actions for the bookmark.
const DescriptionData: React.FC<DescriptionProps> = ({ data, onHandleClick, removeFromBookmark }) => {

  return (
    <div className="desciption-data">
      <div className="title-bookmark">
        <h5 className="f-w-600">{data.title}</h5>
        <p>{data.website_url}</p>
        <div className="hover-block">
          <ul>
            <li><a href={Href} onClick={() => onHandleClick(data)}><Edit2 /></a></li>
            <li><a href={Href}><Link /></a></li>
            <li><a href={Href}><Share2 /></a></li>
            <li><a href={Href} onClick={() => removeFromBookmark(data.id)}><Trash2 /></a></li>
            <li className="text-end"><a href={Href}><Tag /></a></li>
          </ul>
        </div>
        <div className="content-general">
          <p>{data.desc}</p>
          <span>{data.collection}</span>
        </div>
      </div>
    </div>
  );
};

export default DescriptionData;